import { useMediaQuery } from 'react-responsive';
import BREAKPOINTS from '../constants/breakpoints';

export const useIsTablet = () => useMediaQuery({
  maxWidth: BREAKPOINTS.md,
});
